import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";
import { Download } from "../../../common/js/icons";
import { docTypeIcons } from "./documentTypes";

const StyledAttachmentCell = styled(TableCell)({
    fontSize: 14,
});

const StyledSortable = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
});

const StyledDownloadDiv = styled("div")({
    cursor: "pointer",
    float: "right",
});

const StyledMissingDocs = styled(TableCell)({
    color: "red",
});

const StyledAttachmentWarning = styled(TableCell)({
    fontSize: 14,
    color: "red",
});

const DocumentListViewOnly = (props) => {
    const {
        open,
        docMenuKey,
        anchorEl,
        savedDocuments,
        missingRequiredDocuments,
        handleMenuClose,
        handlePreviewDocument,
        handleDownloadDocument,
        handleOpenDocumentMenu,
        includeSource,
        downloadView,
        role,
        documentAttachmentPermissions,
    } = props;

    const isOpenActionDisabledForDocument = () => {
        return savedDocuments[docMenuKey]?.documentType === null
            ? false
            : !documentAttachmentPermissions?.find(
                  (permission) =>
                      permission.documentTypeKey === savedDocuments[docMenuKey]?.documentType?.documentTypeKey
              )?.canRead;
    };

    const isMenuButtonDisabled = (mediaAssetKey) => {
        const documentType = savedDocuments[mediaAssetKey]?.documentType;
        if (!documentType) return false;

        const permission = documentAttachmentPermissions?.find(
            (p) => p.documentTypeKey === documentType?.documentTypeKey
        );

        return !permission?.canRead;
    };

    const columnDefs =
        includeSource === true
            ? [
                  { display: "Name", prop: "mediaAssetName" },
                  { display: "Document Source", prop: "ownerType" },
                  { display: "Document Type", prop: "mediaAssetType" },
                  { display: "Required" },
                  { display: "" },
              ]
            : [
                  { display: "Name", prop: "mediaAssetName" },
                  { display: "Document Type", prop: "mediaAssetType" },
                  { display: "" },
              ];
    return (
        <Table>
            <TableHead>
                <TableRow>
                    {columnDefs.map((x, i) => (
                        <TableCell key={`doc-head-${i}`}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <StyledSortable>{x.display}</StyledSortable>
                            </div>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {role !== "auditor" &&
                    missingRequiredDocuments.map((doc, i) => {
                        const { name, type } = doc;
                        return (
                            <TableRow key={`tr-missing-${i}`} data-testid={`Missing-${name}`}>
                                <StyledAttachmentWarning>
                                    <span>Missing Required Document - {name}</span>
                                </StyledAttachmentWarning>
                                {includeSource === true && (
                                    <StyledAttachmentWarning>
                                        <span>{type}</span>
                                    </StyledAttachmentWarning>
                                )}
                                <StyledMissingDocs>
                                    <div>{name}</div>
                                </StyledMissingDocs>
                                <StyledMissingDocs>Yes</StyledMissingDocs>
                                <TableCell />
                            </TableRow>
                        );
                    })}
                {Object.keys(savedDocuments).map((x, i) => {
                    const document = savedDocuments[x];
                    const excludeDocTypeIds = [49, 50];
                    const docType = get(document, "documentType", "");
                    const docTypeId = get(docType, "documentTypeKey", "");
                    const docTypeName = get(docType, "name", "");
                    if (role === "auditor" && excludeDocTypeIds.includes(docTypeId)) {
                        return null;
                    }
                    return (
                        <TableRow key={`tr-doc-${i}`}>
                            <StyledAttachmentCell>
                                {get(
                                    docTypeIcons,
                                    get(document, "mediaAssetName", " ").split(".").pop().toLowerCase(),
                                    docTypeIcons["default"]
                                )()}
                                <span> {document["mediaAssetName"]}</span>
                            </StyledAttachmentCell>
                            {includeSource === true && (
                                <StyledAttachmentCell>
                                    <span> {document["ownerType"]}</span>
                                </StyledAttachmentCell>
                            )}
                            <TableCell>
                                <div>{docTypeName}</div>
                            </TableCell>
                            {includeSource === true && <TableCell>{document?.required ? "Yes" : "No"}</TableCell>}
                            {downloadView === true ? (
                                <TableCell style={{ paddingRight: "0px" }}>
                                    <StyledDownloadDiv onClick={() => handleDownloadDocument(document)}>
                                        <Download />
                                    </StyledDownloadDiv>
                                </TableCell>
                            ) : (
                                <TableCell>
                                    <div>
                                        <IconButton
                                            disabled={isMenuButtonDisabled(x)}
                                            aria-label="More"
                                            aria-owns={Boolean(document["anchorEl"]) ? `long-menu-${x}-${i}` : null}
                                            aria-haspopup="true"
                                            onClick={(e) => handleOpenDocumentMenu(x, e.currentTarget)}
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                        <Menu
                                            id="long-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleMenuClose}
                                            slotProps={{
                                                paper: {
                                                    style: {
                                                        width: 200,
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem
                                                disabled={isOpenActionDisabledForDocument()}
                                                onClick={() =>
                                                    handlePreviewDocument(get(document, "url", null), docMenuKey)
                                                }
                                            >
                                                Open in a new tab
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                </TableCell>
                            )}
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default DocumentListViewOnly;
